<template>
  <footer class="py-3 footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="mb-4 col-lg-6 mb-lg-0">
          <div
            class="text-sm text-center copyright text-muted"
            :class="this.$store.state.isRTL ? 'text-lg-end' : 'text-lg-start'"
          >
            ©
            {{ new Date().getFullYear() }}, made with
            <i class="fa fa-heart"></i> in
            <a
              href="https://www.creative-tim.com"
              class="font-weight-bold"
              target="_blank"
              >El Salvador</a
            >
          </div>
        </div>
        <div class="col-lg-6">
          <ul
            class="nav nav-footer justify-content-center justify-content-lg-end"
          ></ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  inheritAttrs: false,
  name: "app-footer",
};
</script>
